import { createFileRoute, Link } from "@tanstack/react-router";
import { Section } from "@/components/landing/Section";
import { jsonLdScript } from "@/lib/marketing-jsonld";
import {
  privacyBreadcrumbJsonLd,
  privacyJsonLd,
  privacyRouteHead,
} from "@/lib/privacy-seo";
import { renderPrivacyPolicyHtml } from "@/lib/privacy-policy";

// Head/meta and structured data are owned by `src/lib/privacy-seo.ts`, the
// rendered body by `src/lib/privacy-policy.ts` (see their docblocks); this
// module only places them. The renderer is referenced from the component only,
// so the code splitter carries markdown-it and the policy text in this route's
// chunk rather than the entry. Under `_home` like every other marketing
// sub-page, so the policy gets the site header and footer: `about.tsx` sits
// outside that layout and has neither.
export const Route = createFileRoute("/_home/privacy")({
  ssr: true, // public SEO route (D-216-5); the Connectors Directory fetches it
  head: privacyRouteHead,
  component: PrivacyPage,
});

function PrivacyPage() {
  // Memoised inside `privacy-policy.ts`; the source is a static file.
  const policyHtml = renderPrivacyPolicyHtml();
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdScript(privacyJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdScript(privacyBreadcrumbJsonLd) }}
      />
      <nav aria-label="Breadcrumb" className="sr-only">
        <ol>
          <li>
            <Link to="/">Home</Link>
          </li>
          <li aria-current="page">Privacy</li>
        </ol>
      </nav>
      <main>
        <Section>
          {/* `.gs-reading` is the published post's prose surface: serif body,
              real headings and lists under Tailwind's preflight, and the
              scrolling table region the CCPA appendix needs at phone width. */}
          <article
            className="gs-reading"
            dangerouslySetInnerHTML={{ __html: policyHtml }}
          />
        </Section>
      </main>
    </>
  );
}
